import { SchoonheidsModal } from './Modals/SchoonheidsModal';
import { MassageModal } from './Modals/MassageModal';
import { HybridBrowsModal } from './Modals/HybridBrowsModal';

interface Props {
    activeModal?: string;
}

export const Modal = ({activeModal}: Props) => {

    return (
        <div className={`modal ${!!activeModal && 'is-active'}`}>
            <div className="modal-content-wrapper">
                <div className="modal-title-wrapper">
                    <div className="modal-icon">
                        <img src='https://img.icons8.com/wired/64/000000/euro-pound-exchange.png' alt='modal icon'/>
                    </div>
                    <h2 className="modal-title">{activeModal}</h2>
                </div>
                {activeModal === 'Gezichtsbehandelingen' 
                ? <SchoonheidsModal/> 
                : activeModal === 'Massages' 
                    ? <MassageModal/> 
                    : activeModal === 'Hybrid Brows'
                        ? <HybridBrowsModal/>
                        : null
                }
            </div>
        </div>
        )
}